import { useTranslation } from "react-i18next";
import type { ActionPlanTemplate } from "src/api/client-api/actionPlanTemplates/useActionPlanTemplates";

export type PublishableTemplate = Pick<ActionPlanTemplate, "name" | "ssqId" | "sectorId" | "actionCount">;

export const useTemplatePublicationBlocker = (template: PublishableTemplate | undefined) => {
    const { t } = useTranslation();

    if (!template) return "";

    const missing = [];

    if (!template.name.trim()) {
        missing.push(t("settings.action_plan_templates.publish.requires_name", "Add a name before publishing."));
    }

    if (!template.ssqId) {
        missing.push(t("settings.action_plan_templates.publish.requires_ssq", "Select an SSQ before publishing."));
    }

    if (!template.sectorId) {
        missing.push(
            t("settings.action_plan_templates.publish.requires_sector", "Select an industry sector before publishing."),
        );
    }

    if (template.actionCount === 0) {
        missing.push(
            t("settings.action_plan_templates.publish_requires_action", "Add at least one action before publishing."),
        );
    }

    return missing.join(" ");
};
